import React from "react";

const InlineLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  return (
    <>
      {" "}
      <a
        className={"text-underlined text-blue-100"}
        target={"_blank"}
        href={href}
        rel="noreferrer"
      >
        {children}
      </a>{" "}
    </>
  );
};

export default InlineLink;
